export const setClarityUserId = (customerId: string) => {
    // Identify user after Clarity script loads
    if (typeof window !== "undefined" && window.clarity) {
        window.clarity("identify", customerId, undefined, undefined, customerId);
    }
};

export const setClarityTag = (key: string, value: string) => {
    if (typeof window !== "undefined" && window.clarity) {
        window.clarity("set", key, value);
    }
};